import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchSimulation } from '../client';
import type { SimulationResponse } from '../client';
import { useSimulationId } from './useSimulationId';

export function useStartSimulation() {
  const simId = useSimulationId();
  const queryClient = useQueryClient();

  const mutation = useMutation<SimulationResponse, Error, void>({
    mutationFn: async () => {
      const { data } = await patchSimulation({
        path: { sim_id: simId },
        body: { state: 'running' },
        throwOnError: true,
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['simulation', simId] });
    },
  });

  return mutation;
}
